module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraLightItalic.05139b65.ttf";